<div class="offcanvas-header">
  <h5 id="offcanvasRightLabel">Cliente: {{ client.nomeCliente }}</h5>
  <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"
    (click)="onClose()"></button>
</div>
<div class="offcanvas-body overflow-auto">
  <form [formGroup]="novaMensagemForm" (ngSubmit)="onSubmit($event)">
    <div class="mb-3">
      <label for="status" class="form-label">Status</label>
      <select formControlName="statusId" class="form-select" name="statusId">
        <option value="">Selecione um status</option>
        <option *ngFor="let status of statusMessages" [value]="status.id">
          {{ status.nome | statusCorFormatter:'nome' }}
        </option>
      </select>
    </div>

    <div class="mb-3">
      <label for="scheduledDate" class="form-label">Agendamento</label>
      <input formControlName="dataAgendamento" type="date" class="form-control" name="dataAgendamento" />
    </div>
    
    <div class="mb-3">
      <label for="mensagens" class="form-label">Mensagens</label>
      <div id="mensagens" class="mensagens-container">
        @for (mensagem of clientRequest?.mensagens; track mensagem.mensagemId) {
        <div class="mensagem-item">
          <p class="mensagem-text">
            @if (mensagem.mensagemRelevante) {
              <i class="mdi mdi-star text-warning me-2" title="Mensagem Relevante"></i>
            }
            {{ mensagem.mensagem }}
          </p>
          <small class="mensagem-data">
            {{ mensagem.dataCadastro | date: "short" }}
          </small>
        </div>
        }
        @if (clientRequest?.mensagens?.length === 0) {
        <p class="text-muted">Nenhuma mensagem cadastrada</p>
        }
      </div>
    </div>

    <div class="mb-3">
      <label for="mensagemPersonalizada" class="form-label">
        Mensagens personalizadas
      </label>
      <select class="form-select" 
        id="mensagemPersonalizada"
        formControlName="mensagemPersonalizada"
        (change)="onMensagemSelecionada($event)">
        <option value="">Selecione uma mensagem</option>
        @for (customMessage of customMessages; track customMessage.id) {
        <option value="{{customMessage.id}}">
          {{ customMessage.titulo }}
        </option>
        }
      </select>
    </div>
    <div class="mb-3">
      <label for="message" class="form-label">Nova Mensagem</label>
      <textarea formControlName="mensagem" class="form-control" rows="3"
        [value]="selectedCustomMessage?.mensagem || ''"></textarea>

      <div *ngIf="novaMensagemForm.get('mensagem')?.touched 
        && novaMensagemForm.get('mensagem')?.hasError('required')"
        >
        <small style="color: red;">
          Informe uma mensagem válido.
        </small>
      </div>

      <div class="mb-3 d-flex align-items-center mt-2">
        <label class="form-check-label" for="mensagemRelevante">Marcar mensagem como Relevante</label>
        <div class="form-check form-switch mx-2">
          <input 
            [checked]="novaMensagemForm.get('mensagemRelevante')?.value"
            formControlName="mensagemRelevante" 
            type="checkbox" 
            class="form-check-input"
            id="mensagemRelevante" />
        </div>
      </div>

    </div>
    <div>
      
      <div class="mb-3 d-flex align-items-center">
        <label class="form-check-label" for="qualify">Qualificar Contato</label>
        <div class="form-check form-switch mx-2">
          <input 
      [checked]="novaMensagemForm.get('qualificarContato')?.value"
      formControlName="qualificarContato" type="checkbox" class="form-check-input"
      title="Qualifica o contato e remove da lista." />
        </div>
      </div>
      @if (qualify) {
      <div class="mb-3">
        <small class="text-muted">
          Ao Qualificar um contato ele será excluído da lista atual e será
          inserido na lista de conatatos qualificados
        </small>
      </div>
      }

    </div>
    <div class="d-flex justify-content-md-between">
      <button type="submit" class="btn btn-primary">
        Salvar
      </button>
      <button title="Remover contato da lista" type="submit" class="btn btn-danger" (click)="removerContato = true">
        Remover Contato
      </button>

    </div>
  </form>
</div>